import { render, staticRenderFns } from "./ProjectConfigurationComments.vue?vue&type=template&id=abf45c5a&scoped=true&"
import script from "./ProjectConfigurationComments.vue?vue&type=script&lang=js&"
export * from "./ProjectConfigurationComments.vue?vue&type=script&lang=js&"
import style0 from "./ProjectConfigurationComments.vue?vue&type=style&index=0&id=abf45c5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf45c5a",
  null
  
)

export default component.exports